import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Edit, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, useStore } from "react-admin";
import { Grid } from "@mui/material";
import { activityRequests } from "api/activityApi";
import { studentRequests } from "api/studentApi";
import { CAPACITY_KEY } from "./List";

const EditForeignLanguageCapacity = () => {
  // Read-only consumer of the committed academic year from the capacity list.
  const [filters] = useStore(CAPACITY_KEY, null);
  const academicYearId = filters?.academicYearId ?? null;

  return (
    <Edit
      title="Редактиране капацитет за чужди езици"
      actions={<BackButtonToolbar />}
      mutationMode="pessimistic"
    >
      <SimpleForm>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="academicYearId"
              reference={studentRequests.getAcademicYearsSelect()}
            >
              <SelectInput
                optionText="name"
                label="Академична година"
                readOnly={!!academicYearId}
                validate={[required()]}
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              reference={activityRequests.getActivityForeignLanguagesSelect()}
              source="foreignLanguageId"
            >
              <SelectInput
                label="Избор на чужд език"
                optionText="name"
                validate={[required()]}
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <NumberInput
              source="studentsCapacity"
              label="Капацитет студенти"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EditForeignLanguageCapacity;
